import axios from "axios";
import config from "../../config";
import { getAuthToken } from "../../utils/authStorage";

export const formatLkr = (amount) => {
  const n = Number(amount);
  if (Number.isNaN(n)) return "LKR 0";
  return `LKR ${n.toLocaleString("en-LK", { maximumFractionDigits: 0 })}`;
};

export const fetchMembershipOptions = async () => {
  const response = await axios.get(`${config.apiBaseUrl}/hpc/membership-options`);
  return response.data;
};

// Family prices are always calculated by the server, never in the browser.
export const fetchFamilyQuote = async (membershipType, members) => {
  const response = await axios.post(`${config.apiBaseUrl}/hpc/membership/family-quote`, {
    membershipType,
    members: members.map((m) => ({ fullName: m.fullName, dateOfBirth: m.dateOfBirth })),
  });
  return response.data;
};

// Server price breakdown with an optional promotion code (never calculated in the browser).
export const fetchMembershipQuote = async ({ membershipType, members, promoCode, nicPassport }) => {
  const response = await axios.post(`${config.apiBaseUrl}/hpc/membership/quote`, {
    membershipType,
    members: (members || []).map((m) => ({ fullName: m.fullName, dateOfBirth: m.dateOfBirth })),
    promoCode,
    nicPassport,
  });
  return response.data;
};

// Saved family breakdown and the expected next payment (staff only).
export const fetchFamilyDetails = async (membershipId) => {
  const token = getAuthToken();
  const response = await axios.get(
    `${config.apiBaseUrl}/hpc/admin/registrations/${membershipId}/family`,
    { headers: token ? { Authorization: `Bearer ${token}` } : {} },
  );
  return response.data.family;
};

export const FAMILY_PAYMENT_KIND_LABELS = {
  initial: "First family payment (registration total)",
  renewal: "Family renewal (current ages and prices)",
  late_member: "New family member joining fee",
  covered_by_main_member: "Covered by the main member's payment",
};

export const applyPackageToForm = (pkg, setFieldValue) => {
  if (!pkg) return;
  setFieldValue("membershipType", pkg.id);
  setFieldValue("membershipFee", String(pkg.membershipFee));
  setFieldValue("registrationFee", String(pkg.admissionFee));
  setFieldValue("totalAmountPaid", String(pkg.totalFee));

};

export const splitPackages = (packages = []) => ({
  foundingAdult: packages.filter((p) => p.category === "founding" && p.audience === "adult"),
  foundingStudent: packages.filter((p) => p.category === "founding" && p.audience === "student"),
  commitmentAdult: packages.filter((p) => p.category === "commitment" && p.audience === "adult"),
  commitmentStudent: packages.filter((p) => p.category === "commitment" && p.audience === "student"),
  // Couple plans are rendered in a dedicated section to avoid mixing with single-member plans.
  coupleAdult: packages.filter((p) => p.category === "couple" && p.audience === "adult"),
  family: packages.filter((p) => p.category === "family"),
});

